import { ajax } from '../../utils/fetch';

import { statusMsg, sanitizeName } from '../../utils/utils';

const templateCropPopup = document.createElement('template');

templateCropPopup.innerHTML = `<section class="popup crop-popup" id="crop-popup" content="">
                           <div class="crop-content">
                           <div class="crop-body"></div>
                           <div class="crop-footer"></div>
                           </div>
                           </section>`;

const templateCropBody = document.createElement('template');
templateCropBody.innerHTML = `<img class="crop-image" src="" style="max-width: 100%;display: block;">`;

const templateSaveCancelForCrop = document.createElement('template');

templateSaveCancelForCrop.innerHTML = `<button class="btn-cta save-image">Save</button><button class="btn cancel-btn">Cancel</button>`;

const templateLandingContactDetails = document.createElement('template');

templateLandingContactDetails.innerHTML = `<section class="contact-info container t-c vertical-margin mh-a">
                                            <span class="au-dot left"></span>
                                            <span class="au-dot right"></span>
                                            <div class="fx heading">
                                            <h2 class="title mh-a">Contact Us</h2>
                                            <div class="ml-a noedit"> 
                                                <button class="link link-accept start-edit">Edit</button>
                                                <div class="editing">  
                                                <button class="link link-accept save">Save</button>
                                                <button class="link link-reject cancel">Cancel</button>
                                                </div>
                                            </div>
                                            </div>
                                            <div class="t-c">
                                            <p class="text editable mb-18 address1 hide" data-placeholder ="Address 1"></p>
                                            <br />
                                            <p class="text editable mb-18 address2 hide" data-placeholder ="Address 2"></p>
                                            <div class="mb-18">
                                                <a class="text editable static-look email hide" data-placeholder ="Mail Address" href="mailto:"></a>
                                                <a class="text editable phone hide" href="tel:"  data-placeholder ="Phone Number"></a>
                                            </div>
                                            <div class="fx flex-text-center media-links">
                                                <a class="text editable mr-18 website hide" target="_blank">
                                                <label for="website">
                                                <img class="website" src="https://storage.googleapis.com/adaptiveyou/adaptiveu-v2/icons/link-icon.svg" alt="">
                                                </label>
                                                <input type="text" id="website" placeholder="WebSite">
                                                </a>
                                                <a class="text editable mr-18 facebook hide" target="_blank">
                                                <label for="facebook">
                                                    <img src="https://storage.googleapis.com/adaptiveyou/adaptiveu-v2/icons/facebook-icon.svg" alt="">
                                                </label>
                                                <input type="text" id="facebook" placeholder="FaceBook" >
                                                </a>
                                                <a class="text editable mr-18 instagram hide" target="_blank">
                                                <label for="instagram">
                                                    <img src="https://storage.googleapis.com/adaptiveyou/adaptiveu-v2/icons/instagram-icon.svg" alt="">
                                                </label>
                                                <input type="text" id="instagram" placeholder="Instagram">
                                                </a>
                                                <a class="text editable mr-18 twitter hide" target="_blank">
                                                <label for="twitter">
                                                    <img src="https://storage.googleapis.com/adaptiveyou/adaptiveu-v2/icons/twitter-icon.svg" alt="">
                                                </label>
                                                <input type="text" id="twitter" placeholder="Twitter">
                                                </a>
                                            </div>
                                            </div>
                                         </section>`;

export default class LandingContactUs extends HTMLElement {
  constructor() {
    super();

    this._root = this;
  }

  static get observedAttributes() {
    return ['semanticname', 'mode'];
  }

  set semanticname(val) {
    if (val) this.setAttribute('semanticname', val);
  }

  get semanticname() {
    return this.getAttribute('semanticname');
  }

  set mode(val) {
    if (val) this.setAttribute('mode', val);
  }

  get mode() {
    return this.getAttribute('mode');
  }

  connectedCallback() {
    this.appendChild(templateLandingContactDetails.content.cloneNode(true));
  }

  attributeChangedCallback(name, oldVal, newVal) {
    if (name === 'semanticname' && newVal) {
      if (this._contactDetails) {
        this._renderContactUs(this._contactDetails);
      }
    }
    if (name === 'mode' && newVal && newVal === 'edit') {
      this._bindEvents();
      this._removeHide();
    }
  }

  _removeHide() {
    try {
      this.querySelector('.contact-info')
        .querySelectorAll('.editable')
        .forEach(editable => {
          editable.classList.remove('hide');
        });
    } catch (error) {
      console.error(`Error while removing hide ${error}`);
    }
  }

  _bindEvents() {
    this.querySelector('.save').addEventListener('click', () => {
      this._saveContactDetails();

      this._addOrRemoveEditMode(
        this.querySelector('.contact-info'),
        'remove',
        'save'
      );
    });
    this.querySelector('.cancel').addEventListener('click', () => {
      this._addOrRemoveEditMode(
        this.querySelector('.contact-info'),
        'remove',
        'cancel'
      );
    });

    this.querySelector('.start-edit').addEventListener('click', () => {
      this._addOrRemoveEditMode(
        this.querySelector('.contact-info'),
        'add',
        'edit'
      );
    });
  }

  _addOrRemoveEditMode(element, action, mode) {
    try {
      if (action === 'add') {
        element.classList.add('edit-mode');
        element.querySelector('.editable').focus();
        element.querySelectorAll('.editable').forEach(editable => {
          editable.setAttribute('contenteditable', true);
          editable.classList.remove('hide');
        });
      } else if (action === 'remove') {
        element.classList.remove('edit-mode');
        element.querySelectorAll('.editable').forEach(editable => {
          editable.removeAttribute('contenteditable');
        });
      }
    } catch (e) {
      console.error(
        `Error while add or remove edit mode contact us:: ${e.message}`
      );
    }
  }

  _renderContactUs(contactDetails) {
    try {
      if (contactDetails) {
        let detailsExist = false;
        const $contact = this.querySelector('.contact-info');
        contactDetails = JSON.parse(contactDetails);

        const address = contactDetails.address1
          ? contactDetails.address1
          : contactDetails.address;
        if (address) {
          $contact.querySelector('.address1').innerText = address;
          $contact.querySelector('.address1').classList.remove('hide');
          detailsExist = true;
        } else {
          $contact.querySelector('.address1').innerText = '';
        }
        if (contactDetails.address2) {
          $contact.querySelector('.address2').innerText =
            contactDetails.address2;

          $contact.querySelector('.address2').classList.remove('hide');
          detailsExist = true;
        } else {
          $contact.querySelector('.address2').innerText = '';
        }

        if (contactDetails.email) {
          $contact.querySelector('.email').innerText = contactDetails.email;
          $contact.querySelector(
            '.email'
          ).href = `mailto:${contactDetails.email}`;

          $contact.querySelector('.email').classList.remove('hide');
          detailsExist = true;
        } else {
          $contact.querySelector('.email').innerText = '';
        }

        if (contactDetails.phone) {
          $contact.querySelector('.phone').innerText = contactDetails.phone;
          $contact.querySelector('.phone').classList.remove('hide');
          detailsExist = true;
        } else {
          $contact.querySelector('.phone').innerText = '';
        }

        if (contactDetails.website) {
          $contact
            .querySelector('.media-links')
            .querySelector(
              '.website'
            ).href = `http://${contactDetails.website
            .replace('http://', '')
            .replace('https://', '')}`;
          $contact
            .querySelector('.media-links')
            .querySelector('#website').value = contactDetails.website;

          $contact
            .querySelector('.media-links')
            .querySelector('.website')
            .classList.remove('hide');
          detailsExist = true;
        } else {
          $contact
            .querySelector('.media-links')
            .querySelector('#website').value = '';
        }

        if (contactDetails.facebook) {
          $contact
            .querySelector('.media-links')
            .querySelector(
              '.facebook'
            ).href = `http://${contactDetails.facebook
            .replace('http://', '')
            .replace('https://', '')}`;
          $contact
            .querySelector('.media-links')
            .querySelector('#facebook').value = contactDetails.facebook;

          $contact
            .querySelector('.media-links')
            .querySelector('.facebook')
            .classList.remove('hide');
          detailsExist = true;
        } else {
          $contact
            .querySelector('.media-links')
            .querySelector('#facebook').value = '';
        }
        if (contactDetails.instagram) {
          $contact
            .querySelector('.media-links')
            .querySelector(
              '.instagram'
            ).href = `http://${contactDetails.instagram
            .replace('http://', '')
            .replace('https://', '')}`;
          $contact
            .querySelector('.media-links')
            .querySelector('#instagram').value = contactDetails.instagram;

          $contact
            .querySelector('.media-links')
            .querySelector('.instagram')
            .classList.remove('hide');
          detailsExist = true;
        } else {
          $contact
            .querySelector('.media-links')
            .querySelector('#instagram').value = contactDetails.instagram;
        }

        if (contactDetails.twitter) {
          $contact
            .querySelector('.media-links')
            .querySelector(
              '.twitter'
            ).href = `http://${contactDetails.twitter
            .replace('http://', '')
            .replace('https://', '')}`;
          $contact
            .querySelector('.media-links')
            .querySelector('#twitter').value = contactDetails.twitter;

          $contact
            .querySelector('.media-links')
            .querySelector('.twitter')
            .classList.remove('hide');
          detailsExist = true;
        } else {
          $contact
            .querySelector('.media-links')
            .querySelector('#twitter').value = contactDetails.twitter;
        }
        if (!detailsExist && this.getAttribute('mode') !== 'edit')
          this.remove();
      }
    } catch (e) {
      console.error(`Error while rendering contactus details :: ${e.message}`);
    }
  }

  _saveContactDetails() {
    try {
      const contactDetails = {};

      contactDetails.address1 = sanitizeName(
        this.querySelector('.address1').innerText.trim()
      );
      contactDetails.address2 = sanitizeName(
        this.querySelector('.address2').innerText.trim()
      );
      contactDetails.email = sanitizeName(
        this.querySelector('.email').innerText.trim()
      );
      contactDetails.phone = sanitizeName(
        this.querySelector('.phone').innerText.trim()
      );

      contactDetails.website = sanitizeName(
        this.querySelector('.media-links')
          .querySelector('#website')
          .value.trim()
      );
      contactDetails.facebook = sanitizeName(
        this.querySelector('.media-links')
          .querySelector('#facebook')
          .value.trim()
      );
      contactDetails.instagram = sanitizeName(
        this.querySelector('.media-links')
          .querySelector('#instagram')
          .value.trim()
      );
      contactDetails.twitter = sanitizeName(
        this.querySelector('.media-links')
          .querySelector('#twitter')
          .value.trim()
      );

      const univDTO = {
        contactDetails: JSON.stringify(contactDetails)
      };

      statusMsg('Saving ...');

      const request = {};

      request.contentType = 'application/json; charset=utf-8';
      request.method = 'PATCH';
      request.url = `/api/v1/university/${this.getAttribute(
        'semanticname'
      )}/subUniversity/contact`;
      request.body = univDTO;

      ajax(request).then(response => {
        if (response.status) {
          this._contactDetails = univDTO.contactDetails;
          this._renderContactUs(univDTO.contactDetails);
        }
        if (response.msg) statusMsg(response.msg);
      });
    } catch (e) {
      console.error(`Error while saving contact details :: ${e.message}`);
    }
  }
}
